export function doubleHelper(number, precision) {
  var newNumber = Number(Math.round(number + 'e' + precision) + 'e-' + precision).toFixed(precision);
  if (isNaN(newNumber))
    return Number(0).toFixed(precision);
  else
    return newNumber;
}